/**
* SurveyController
* @namespace gplans.survey.controllers
*/
(function () {
  'use strict';SurveyController.$inject = ["$rootScope", "$scope", "$http", "$uibModal", "$localStorage", "$location", "$state", "plansConf", "Authentication", "Profile", "Funnel", "UserService"];

  angular.
  module('gplans.survey.controllers').
  controller('SurveyController', SurveyController);

  SurveyController.$inject = ['$rootScope', '$scope', '$http', '$uibModal', '$localStorage', '$location', '$state', 'gplansConf', 'Authentication', 'Profile', 'Funnel', 'UserService'];

  /**
                                                                                                                                                                                         * @namespace SurveyController
                                                                                                                                                                                         */
  function SurveyController($rootScope, $scope, $http, $uibModal, $localStorage, $location, $state, plansConf, Authentication, Profile, Funnel, UserService) {
    var modalInstance;

    activate();

    /**
                * @name activate
                * @desc Actions to be performed when this controller is instantiated
                * @memberOf gplans.survey.controllers.SurveyController
                */
    function activate() {
      //var step = Funnel.getStep();
      //Funnel.redirect(step);
      var offerId = $location.search().funnelType;
      if (offerId == 'straightSale')
      $rootScope.offerId = 'straightSale';
      $rootScope.pageTitle = 'Survey';
      $scope.formData = {};
      $scope.fetchUserSurveyAnswers = function () {
        // todo: move to Survey Service
        $http.get(gplansConf.API_URL + '/api/v1/usersurveys/' + $scope.usersurvey.id + '/surveyanswers/').then(function (data) {
          $scope.userSurveyAnswers = data.data;
        });
      };
      $scope.$watch('usersurvey', function (newVal, oldVal) {
        // todo: move to Survey Service
        if ('undefined' === typeof newVal) return;
        $scope.fetchUserSurveyAnswers();
      });
      // $http.get(gplansConf.API_URL+'/api/v1/surveys/'+$stateParams.surveyId+'/').then(function(data){
      //   $scope.survey = data.data;
      // });

      // todo: move to Survey Service
      if ($localStorage['userSurvey']) {
        $http.get(gplansConf.API_URL + '/api/v1/usersurveys/' + $localStorage['userSurvey'] + '/').then(function (data) {
          $scope.usersurvey = data.data;
        });
      } else {
        $http.post(gplansConf.API_URL + '/api/v1/usersurveys/', { survey: 1 }).then(function (data) {
          $scope.usersurvey = data.data;
          $localStorage['userSurvey'] = $scope.usersurvey.id;
        });
      }

      // $http.get(gplansConf.API_URL+'/api/v1/usersurveys/').then(function(data){
      //   $scope.usersurveys = data.data;
      //   if(data.data.length) {
      //     $scope.usersurvey = data.data[data.data.length-1];
      //   } else {
      //     $http.post(gplansConf.API_URL+'/api/v1/usersurveys/', {survey: 1}).then(function(data){
      //       $scope.usersurvey = data.data;
      //     });
      //   }
      // });

      // vm.user = Authentication.getAuthenticatedAccount();

      $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        if (UserService.data.id && $rootScope.offerId == 'straightSale') {
          Profile.updateMisc({
            key: 'lastViewedPage',
            value: JSON.stringify({
              state: toState.name,
              params: toParams }) }).

          then(function (res) {
            // console.log(res);
          }, function () {
            Profile.createMisc({
              key: 'lastViewedPage',
              value: JSON.stringify({
                state: toState.name,
                params: toParams }) });


          });
        }
      });

    }
  }
})();